module.exports = __webpack_public_path__ + "13_hair_black.df341795.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/13_hair_black.png
// module id = /3KD
// module chunks = 0